import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { TransportOrderIdView } from '../../../../models/shipment-id-view.model';
import { API_URL } from '../../../../../services/config';
import { Observable } from 'rxjs';
import { ShipmentTransportOrderOverview } from '../../models/shipment-transport-order.model';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { ShipmentTransportOrderEndpoint } from '../../constants';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderMainInfoService {
  constructor(private http: WrapperHttpService) {}

  getOverviewData(transportOrderIdView: TransportOrderIdView): Observable<ShipmentTransportOrderOverview> {
    return this.http
      .withLoading()
      .get<ShipmentTransportOrderOverview>(
        `${API_URL}${ShipmentTransportOrderEndpoint.Base}${ShipmentTransportOrderEndpoint.Tos}${
          ShipmentTransportOrderEndpoint.Summary
        }?${getQueryStringFromObject(transportOrderIdView)}`,
      );
  }
}
